module.exports = __webpack_public_path__ + "img/15@3x.a5e381e8.png";